import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { NavigationExtras,  ActivatedRoute } from '@angular/router';
import {ActionSheetController, ModalController, NavController, Platform, IonSlides} from '@ionic/angular';
import { Utils } from 'src/app/Models/Classes/utils';
import { FriendshipService } from 'src/app/services/relations/relations.service';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import {ActualizacionServiceService} from "../../../services/actualizacion/Actualizacion-service.service";
import {ProfilePage} from "../../../pages/profile/profile.page";
import {UserContact} from "../../../Models/Classes/User/user-contact";
import {ChatService} from "../../../services/chat/chat.service";
import {Conversation} from "../../../Models/Classes/Chat/conversation";
import {isImage} from "../../../utils";
import Swal2 from "sweetalert2";
import {UploadMultimediaService} from "../../../services/upload/upload-multimedia.service";
import {Capacitor} from "@capacitor/core";
import {RequestService} from "../../../services/request/request.service";
import {FormServiceService} from "../../../services/publications/form-service.service";
//import { Profile } from './../../../Models/Classes/User/profile';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { Camera, CameraResultType, CameraSource, Photo, CameraOptions } from '@capacitor/camera';
import { ChangeDetectorRef } from '@angular/core';
import { Plugins } from '@capacitor/core';
const { LocalNotifications } = Plugins;
import { Router } from '@angular/router'; // Import the Router
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import {Title, Meta } from '@angular/platform-browser';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { ProfileGameComponent } from '../profile-game/profile-game.component';
import { ShareProfileModalComponent } from '../share-profile-modal/share-profile-modal.component';
import { ProfileSongPickerComponent } from '../profile-song-picker/profile-song-picker.component';
import { ProfileVoiceRecorderComponent } from '../profile-voice-recorder/profile-voice-recorder.component';
import { ProfileTopFivePickerComponent } from '../profile-top-five-picker/profile-top-five-picker.component';
import { ProfileEditModalComponent } from '../profile-edit-modal/profile-edit-modal.component';
import { NativeHaptics as Haptics } from 'src/app/plugins/native-runtime.plugins';

import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { StoryViewerComponent } from 'src/app/components/stories-bar/story-viewer/story-viewer.component';

interface ExperienceData {
  position: string;
  company: string;
  duration: string;
  description: string;
  logo: string | ArrayBuffer | null; // Use appropriate type for the logo (base64 data URL)
}
interface EducationData {
  institution: string;
  degree: string;
  year: string;
  logo: string | ArrayBuffer | null; // The logo can be a string (Data URL), ArrayBuffer, or null
}

@Component({
	selector: 'app-sections-profile',
	templateUrl: './sections-profile.component.html',
	styleUrls: ['./sections-profile.component.scss'],
})
export class SectionsProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  causes: string[] = [
   
  ];
  experiences = [
   
  ];

  educationList = [

  ];

  languages = [];

  skills = [];
  profileMusicTracks: any[] = [];
  profileMusicLoading = false;
  profileMusicIndex = 0;
  profileMusicPlaying = false;
  profileMusicProgress = 0;
  profileMusicDuration = 0;
  @ViewChild('profileSpotifyEmbedHost') profileSpotifyEmbedHost?: ElementRef<HTMLDivElement>;
  private profileSpotifyApi?: any;
  private profileSpotifyApiPromise?: Promise<any>;
  private profileSpotifyController?: any;
  private profileSpotifyControllerPromise?: Promise<any>;
  private profileSpotifyLoadedUri = '';
  private profileSpotifyUriReady = false;
  private profileSpotifyPlayWhenLoaded = false;
  private profileSpotifyCanPlayAfter = 0;
  profileTopFive: any[] = [];
  profileTopFiveLoading = false;
  profileSocialSummary = {
    friends: 0,
    mutualFriends: 0,
    comments: 0,
    mutualPreview: [] as any[],
  };
  profileSocialSummaryLoading = false;
  profileComments: any[] = [];
  profileCommentDraft = '';
  profileCommentSubmitting = false;
  profileVoiceMessageAvailable = false;
  followActionPending = false;
  friendActionPending = false;
  profileDetailTab: 'bio' | 'mood' = 'bio';
  readonly profileMoodOptions = ['😀', '🥰', '😎', '🤩', '🥳', '😌', '🤔', '😴', '😤', '😢'];
  selectedProfileMood = '';
  change_story_activated;
  video_is_playing;//stories
  index=0; //stories
 // checkIntervalId;
	@Input() stories;
  @ViewChild('slides') slides: IonSlides;
  public typeTextCalled:boolean=false;
  public web : boolean=false;
  public available_publication_sections: Array<string> = ["Popular", "Reciente", "Proliferado"];
	public icons_for_publication_sections: Array<string> = [ "podium", "time-sharp", "git-compare" ];
  public actual_publication_section: string = "Reciente";
  ///start main pubs
  public main_available_publication_sections: Array<string> = ["EN LA APP", "TERCEROS", ];
	public main_icons_for_publication_sections: Array<string> = [ "aperture-sharp", "git-network-sharp",  ];
  public main_actual_publication_section: string = "EN LA APP";
  //en main pubs

  editedDescription: string;
  editedWebPage: string;
isEditing: boolean = false;
  type:any;
  public formattedURLs: any;
  public counters: any;
  public filtros_disponibles = new Array<string>();
	public filtro_actual: string = "Cuentas";
	public texto_buscado: string;
	public refrescar: number = 0;
	public publications: any[] = [];
	@Input() multimedia: Array<MediaItem>;
	@Input() actualSection: string;
	@Input() profile_id: number;
	@Input() focusPublicationId: number | null = null;
	@Input() owner: boolean;
	@Input() profile: any;
	@Input() profileControlsFaded = false;
  @Input() premiumVisible = false;
  @Output() reloadProfile = new EventEmitter();
  @Output() profileScrollState = new EventEmitter<boolean>();
  @Output() premiumAction = new EventEmitter<void>();
  @Output() openInMycelium = new EventEmitter<void>();
  profile_photo: string = null;
  mostrar:boolean=true
  profileinfo:any;
  isKYCValid: boolean = false;
	private paginatorIndex: number = 1;

	public available_sections: Array<string> = [ "Amigos", "Siguiendo", "Seguidores", "Súper Amigos"];
	public friendships_filter: string = "Amigos";
  public relations: Array<any>;
  public filteredRelations: Array<any>;
  public filteringRelation:boolean=false;
  private relationPage: number = 1;
  private loadingRelationsPage: boolean = false;
  private hasMoreRelations: boolean = true;
  private relationTextDebounceTimer?: ReturnType<typeof setTimeout>;
  private relationFilterDebounceTimer?: ReturnType<typeof setTimeout>;
  private relationSearchCache = new Map<string, Array<any>>();
  private lastRelationTextValue = '';
  private lastRelationFilterValue = '';
	public profileStoryPublications: any[] = [];
	public profileHasStories = false;
	public profileHasUnseenStories = false;
	public profileAllStoriesSeen = false;
	private storiesSubscription?: Subscription;
	private storyRequestSequence = 0;
	mostrar_enlace='Mostrar';

  // Beautiful qubit/atom loader (replaces basic utils.loadingPresent in key flows)
  showQubitLoader = false;
  showProfileSkeleton = false;
  profilePublicationsLoadError = false;
  openingDirectMessage = false;
  qubitTitle = 'Cargando sección';
  qubitSubtitle = 'Sincronizando relaciones y datos del perfil en la red cuántica.';
  profileSkeletonSlots = [0, 1, 2];
  profilePostSkeletonSlots = [0, 1];
  profilePostActionSlots = [0, 1, 2, 3, 4];
  private profileLoaderTimers: Array<ReturnType<typeof setTimeout>> = [];
  mediaType: string;
  private friendsArrayHeader = Array<string>();
  private friendsArrayMessage = Array<string>();
  private profileControlsAreFaded = false;
  private profileViewRecorded = false;

  /** Keep profile navigation chrome collapsed while moving through posts. */
  collapsePostChromeOnSwipe(): void {
    if (this.actualSection !== 'Posts') return;
    this.profilePage.mostrar = false;
    this.formService.mostrar = false;
  }

  private superArrayHeader = Array<string>();
  private superArrayMessage = Array<string>();

	constructor(
		public publicationService: PublicationService,
		private profileService: ProfileService,
		private navCtrl: NavController,
    private camera: CameraServiceService,
    public friendshipService: FriendshipService,
		private utils: Utils,
		private cameraService: CameraServiceService,
		private inputAlertController: InputAlertControllerService,
    private actualizacionService: ActualizacionServiceService,
    public profilePage: ProfilePage,
    private chatService: ChatService,
    private inputAlert: InputAlertControllerService,
    private modalController: ModalController,
    private actionSheetController: ActionSheetController,
    private uploadMedia: UploadMultimediaService,
    private request: RequestService,
    private formService: FormServiceService,
    private route: ActivatedRoute,
		private plaftorm: Platform,
    public walletService: WalletServiceService,
    private ref: ChangeDetectorRef,
    public router: Router,
    private clipboard: Clipboard,
    private metaService: Meta,
    private titleService: Title,
    private popoverCtrl: PopoverController,
    private socialNotifications: SocialInteractionNotificationService
  ) {
    // No longer showing on constructor - will show deliberately after loading completes
    this.plaftorm.ready().then(()=>{
			this.route.queryParams.subscribe(params => {

				if (params['filter']) {
					this.filtro_actual = params['filter'];
					this.refrescar += 1;
					
				}
	
			});
		});

   }
   call_emitChange(event){
	
		this.main_actual_publication_section=event.detail.value;
	}
   async emitChange(event){
     this.publications=[];
		//this.optionChange.emit(event.detail.value);
		this.actual_publication_section = event.detail.value;
    if (this.actual_publication_section==='Popular'){
      this.fetchPublications(true, 'Popular' );
    }else if (this.actual_publication_section==='Reciente'){
      this.fetchPublications(true, 'Reciente' );
    }else if (this.actual_publication_section==='Proliferado'){
      this.fetchPublications(true, 'Proliferado' );
    }
    
	
	  }
    changeMedia(){
      console.log('changeMediaPeriodically called');
    }
	ngOnInit() {
    this.refreshProfileStories();
    this.storiesSubscription = this.publicationService.storiesChanged$.subscribe(() => {
      this.refreshProfileStories();
      this.ref.markForCheck();
    });
    this.loadProfileStories();
    this.publicationService.loadStories().catch(() => {
      // Profile photo and navigation remain available if Stories cannot load.
    });

    if (Capacitor.getPlatform() ==='web'){
      this.web=true;
    }
    this.displayURLs();
    console.log('owner', this.profile.owner);
    // The parent profile page already owns the initial skeleton. Starting a
    // second loader here caused a visible skeleton swap after the profile
    // response mounted this component.
    this.fetchPublications(true);
    this.walletService.KYC_validation3(this.profile.id).then((result_kyc) => {
			console.log('KYC_validation result:', result_kyc);
		  if (result_kyc['permit']) {
			this.formService.isKYCValid = true;
		  }else {
        this.formService.isKYCValid = false;
      }
		});
    this.recordProfileFacadeView();
    this.fetchProfileMusicPlaylist();
    this.fetchProfileTopFive();
    this.fetchProfileSocialSummary();
    this.fetchProfileComments();
    this.fetchProfileVoiceMessageStatus();
    this.selectedProfileMood = this.profile?.mood || '';
    console.log('profile in sections profile', this.profile);
    this.formService.titleHeader = '@' + this.profile.username;
    this.friendsArrayHeader = [
      "Enviar solicitud de amistad",
      "Cancelar solicitud de amistad",
      "Re-enviar solicitud de amistad",
      "Aceptar solicitud de amistad",
      "Eliminar relación de amistad"];
    this.friendsArrayMessage = [
      "¿Deseas enviar una solicitud de amistad a @" + this.profile.username + "?",
      "¿Deseas cancelar tu solicitud de amistad enviada a @" + this.profile.username + "?",
      "¿Deseas enviar nuevamente una solicitud de amistad a @" + this.profile.username + "?",
      "¿Deseas aceptar la solicitud de amistad de @" + this.profile.username + "?",
      "¿Deseas eliminar tu relación de amistad con @" + this.profile.username + "?"];

    this.superArrayHeader = [
      "Enviar solicitud de súper amigos",
      "Cancelar solicitud de súper amigos",
      "Re-enviar solicitud de súper amigos",
      "Aceptar solicitud de súper amigos",
      "Eliminar relación de súper amigos"];
    this.superArrayMessage = [
      "¿Deseas enviar una solicitud de súper amigos a @" + this.profile.username + "?",
      "¿Deseas cancelar tu solicitud de súper amigos enviada a @" + this.profile.username + "?",
      "¿Deseas enviar nuevamente una solicitud de súper amigos a @" + this.profile.username + "?",
      "¿Deseas aceptar la solicitud de súper amigos de @" + this.profile.username + "?",
      "¿Deseas eliminar tu relación de súper amigos con @" + this.profile.username + "?"];

      this.getprofile()
      this.filtros_disponibles.push("Cuentas");
      this.updatePublicProfileMetadata();

      // Loader will be shown after main loading completes (see getprofile + initial load)
	}

  private recordProfileFacadeView(): void {
    if (this.profileViewRecorded) {
      return;
    }

    this.profileViewRecorded = true;
    this.request.createRequestPost('profiles', {}, { id: this.profile_id }, 'views')
      .catch((error) => {
        console.warn('Unable to record profile facade view.', error);
      })
      .finally(() => this.fetchCounters());
  }

  fetchProfileMusicPlaylist(): void {
    this.profileMusicLoading = true;
    this.request.createRequestPost('profile_music_playlist', {
      profile_id: this.profile_id,
    }).then((raw: any) => {
      let data = raw;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch { data = {}; }
      }
      this.profileMusicTracks = Array.isArray(data?.tracks) ? data.tracks : [];
      this.selectProfileMusicTrack(0);
    }).catch(error => {
      console.warn('Unable to load profile music playlist.', error);
      this.profileMusicTracks = [];
      this.profileMusicPlaying = false;
    }).finally(() => {
      this.profileMusicLoading = false;
    });
  }

  async openProfileMusicSelector(): Promise<void> {
    if (!this.profile?.owner) return;
    const modal = await this.modalController.create({
      component: ProfileSongPickerComponent,
      componentProps: { profileId: this.profile_id },
      cssClass: 'profile-tool-sheet-modal',
      canDismiss: true,
    });
    await modal.present();
    const result = await modal.onDidDismiss();
    if (Array.isArray(result?.data?.tracks)) {
      this.profileMusicTracks = result.data.tracks;
      this.selectProfileMusicTrack(Math.min(this.profileMusicIndex, this.profileMusicTracks.length - 1));
    } else if (result?.data) {
      this.fetchProfileMusicPlaylist();
    }
  }

  selectProfileMusicTrack(index: number): void {
    const total = this.profileMusicTracks.length;
    if (!total) {
      this.profileMusicIndex = 0;
      this.profileMusicPlaying = false;
      return;
    }

    this.profileMusicIndex = ((index % total) + total) % total;
    const track = this.profileMusicTracks[this.profileMusicIndex];
    const uri = track?.uri || (track?.id ? `spotify:track:${track.id}` : '');
    this.profileMusicPlaying = false;
    this.profileMusicProgress = 0;
    this.profileMusicDuration = Number(track?.duration_ms || 0);
    if (uri && this.profileSpotifyController) {
      this.profileSpotifyPlayWhenLoaded = false;
      this.runProfileSpotifyCommand(() => this.profileSpotifyController.pause?.());
      this.loadProfileSpotifyUri(this.profileSpotifyController, uri);
    }
  }

  profileMusicCardClass(index: number): string {
    if (!this.profileMusicTracks.length) return '';
    if (index === this.profileMusicIndex) return 'is-active';
    if (index === this.profileMusicIndex - 1) return 'is-previous';
    if (index === this.profileMusicIndex + 1) return 'is-next';
    return 'is-hidden';
  }

  async toggleProfileMusicPlayback(): Promise<void> {
    const track = this.profileMusicTracks[this.profileMusicIndex];
    if (!track) return;
    const controller = await this.prepareProfileSpotifyController(track);
    if (!controller) return;

    if (this.profileMusicPlaying) {
      await this.runProfileSpotifyCommand(() => controller.pause());
      this.profileMusicPlaying = false;
    } else {
      const uri = track?.uri || (track?.id ? `spotify:track:${track.id}` : '');
      if (this.profileSpotifyLoadedUri !== uri) {
        this.profileSpotifyPlayWhenLoaded = true;
        this.profileSpotifyCanPlayAfter = Date.now() + 250;
        this.loadProfileSpotifyUri(controller, uri);
      } else if (!this.profileSpotifyUriReady) {
        this.profileSpotifyPlayWhenLoaded = true;
      } else {
        await this.runProfileSpotifyCommand(() =>
          typeof controller.resume === 'function' ? controller.resume() : controller.play()
        );
      }
    }
  }

  profileMusicProgressPercent(): number {
    if (!this.profileMusicDuration) return 0;
    return Math.max(0, Math.min(100, (this.profileMusicProgress / this.profileMusicDuration) * 100));
  }

  private loadProfileSpotifyApi(): Promise<any> {
    if (this.profileSpotifyApi) return Promise.resolve(this.profileSpotifyApi);
    const spotifyWindow = window as any;
    if (spotifyWindow.__laniakeaSpotifyIframeApi) {
      this.profileSpotifyApi = spotifyWindow.__laniakeaSpotifyIframeApi;
      return Promise.resolve(this.profileSpotifyApi);
    }
    if (this.profileSpotifyApiPromise) return this.profileSpotifyApiPromise;

    this.profileSpotifyApiPromise = new Promise((resolve, reject) => {
      const previousReady = spotifyWindow.onSpotifyIframeApiReady;
      spotifyWindow.onSpotifyIframeApiReady = (api: any) => {
        spotifyWindow.__laniakeaSpotifyIframeApi = api;
        this.profileSpotifyApi = api;
        if (typeof previousReady === 'function') previousReady(api);
        resolve(api);
      };
      const existing = document.querySelector<HTMLScriptElement>(
        'script[src="https://open.spotify.com/embed/iframe-api/v1"]'
      );
      if (existing) {
        existing.addEventListener('error', () => reject(new Error('Spotify IFrame API failed to load')), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://open.spotify.com/embed/iframe-api/v1';
      script.async = true;
      script.addEventListener('error', () => reject(new Error('Spotify IFrame API failed to load')), { once: true });
      document.body.appendChild(script);
    }).finally(() => this.profileSpotifyApiPromise = undefined);

    return this.profileSpotifyApiPromise;
  }

  private prepareProfileSpotifyController(track: any): Promise<any | null> {
    if (this.profileSpotifyController) return Promise.resolve(this.profileSpotifyController);
    if (this.profileSpotifyControllerPromise) return this.profileSpotifyControllerPromise;
    const host = this.profileSpotifyEmbedHost?.nativeElement;
    const uri = track?.uri || (track?.id ? `spotify:track:${track.id}` : '');
    if (!host || !uri) return Promise.resolve(null);

    this.profileSpotifyControllerPromise = this.loadProfileSpotifyApi()
      .then(api => new Promise<any>(resolve => {
        api.createController(host, { uri, width: 1, height: 1 }, (controller: any) => {
          this.profileSpotifyController = controller;
          this.profileSpotifyLoadedUri = uri;
          this.profileSpotifyUriReady = true;
          controller.addListener('playback_started', () => {
            this.profileMusicPlaying = true;
          });
          controller.addListener('playback_update', (event: any) => {
            const state = event?.data || {};
            if (Number.isFinite(state.duration)) this.profileMusicDuration = state.duration;
            if (Number.isFinite(state.position)) this.profileMusicProgress = state.position;
            this.profileMusicPlaying = !state.isPaused && !state.isBuffering;
            if (Number(state.duration) > 0 && Date.now() >= this.profileSpotifyCanPlayAfter) {
              this.profileSpotifyUriReady = true;
            }
            if (
              this.profileSpotifyPlayWhenLoaded
              && this.profileSpotifyUriReady
            ) {
              this.profileSpotifyPlayWhenLoaded = false;
              this.runProfileSpotifyCommand(() => controller.play());
            }
          });
          resolve(controller);
        });
      }))
      .catch(error => {
        console.warn('Profile Spotify playback could not be initialized.', error);
        return null;
      })
      .finally(() => this.profileSpotifyControllerPromise = undefined);

    return this.profileSpotifyControllerPromise;
  }

  private loadProfileSpotifyUri(controller: any, uri: string): void {
    if (!uri || this.profileSpotifyLoadedUri === uri) return;
    this.profileSpotifyLoadedUri = uri;
    this.profileSpotifyUriReady = false;
    this.profileSpotifyCanPlayAfter = Date.now() + 250;
    this.profileMusicProgress = 0;
    this.runProfileSpotifyCommand(() => {
      if (typeof controller.loadUri === 'function') {
        return controller.loadUri(uri);
      }
      return controller.loadEntity(uri, false, 0);
    });
  }

  private async runProfileSpotifyCommand(command: () => any): Promise<void> {
    try {
      await Promise.resolve(command());
    } catch (error) {
      console.warn('Profile Spotify command failed.', error);
      this.profileMusicPlaying = false;
      this.profileSpotifyPlayWhenLoaded = false;
    }
  }

  onFacadeScroll(event: CustomEvent): void {
    const scrollTop = Number(event?.detail?.scrollTop || 0);
    // A little hysteresis prevents the controls from flickering around the
    // threshold when iOS rubber-band scrolling settles.
    const shouldFade = this.profileControlsAreFaded
      ? scrollTop > 14
      : scrollTop > 56;

    if (shouldFade === this.profileControlsAreFaded) return;
    this.profileControlsAreFaded = shouldFade;
    this.profileScrollState.emit(shouldFade);
  }

  async openVoiceMessage(): Promise<void> {
    const modal = await this.modalController.create({
      component: ProfileVoiceRecorderComponent,
      componentProps: {
        profileId: this.profile_id || this.profile?.id,
        owner: Boolean(this.profile?.owner),
      },
      cssClass: 'profile-tool-sheet-modal',
      canDismiss: true,
      backdropDismiss: false,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.saved) this.profileVoiceMessageAvailable = true;
  }

  fetchProfileVoiceMessageStatus(): void {
    this.request.createRequestPost('voice_note_instance', {
      get: true,
      profile_id: this.profile_id || this.profile?.id,
    })
      .then((response) => {
        this.profileVoiceMessageAvailable = Boolean(response?.success?.url);
      })
      .catch((error) => console.error('Unable to load profile voice message status.', error));
  }

  fetchProfileTopFive(): void {
    this.profileTopFiveLoading = true;
    const queryParams = {
      relationDirection: '3',
      relationType: [2],
      relationStatus: '2',
      page: '1',
      profile_id: String(this.profile_id),
    };

    this.friendshipService.getAllRelations(queryParams).then((raw: any) => {
      let data = raw;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch { data = []; }
      }
      const relations = Array.isArray(data) ? data : (data?.data || []);
      // Normalize the API's nested relation tuple once. Keeping those tuples in
      // the view forced Angular to evaluate relation[0] during every change
      // detection pass, including partially populated responses.
      this.profileTopFive = relations
        .map((relation: any) => Array.isArray(relation) ? relation[0]?.user_info : relation?.user_info)
        .filter((user: any) => Boolean(user))
        .slice(0, 5);
    }).catch((error) => {
      console.warn('Unable to load profile Top 5.', error);
      this.profileTopFive = [];
    }).finally(() => {
      this.profileTopFiveLoading = false;
    });
  }

  openTopFiveProfile(user: any): void {
    if (user?.profile_id) {
      this.router.navigate(['/home/profile', user.profile_id]);
    }
  }

  setProfileDetailTab(tab: 'bio' | 'mood'): void {
    this.profileDetailTab = tab;
  }

  selectProfileMood(mood: string): void {
    if (!this.profile?.owner) return;
    const previousMood = this.selectedProfileMood;
    this.selectedProfileMood = mood;
    this.profile.mood = mood;

    this.request.createRequestPost('profile', { attribute: 'mood', value: mood }).catch((error) => {
      console.error('Unable to save profile mood.', error);
      this.selectedProfileMood = previousMood;
      this.profile.mood = previousMood;
    });
  }

  sendProfileReaction(kind: 'poke' | 'cheer' | 'wave'): void {
    if (this.profile?.owner) return;
    const reactions = {
      poke: { icon: '👉', title: 'You received a poke', body: 'Someone poked you on your Laniakea profile.' },
      cheer: { icon: '💗', title: 'Someone cheered for you', body: 'You received a cheer on your Laniakea profile.' },
      wave: { icon: '👋', title: 'Someone waved', body: 'Someone waved at you from your Laniakea profile.' },
    };
    const reaction = reactions[kind];
    this.socialNotifications.notifySuccessfulInteraction({
      recipientProfileId: this.profile_id,
      remoteTitle: `${reaction.icon} ${reaction.title}`,
      remoteBody: reaction.body,
      localTitle: 'Reaction sent',
      localBody: `${reaction.icon} ${reaction.title}`,
      extra: { interaction_type: `profile_${kind}`, profile_id: this.profile_id },
    });
  }

  async startProfileGame(game: 'race' | 'rps'): Promise<void> {
    if (this.profile?.owner) {
      Swal2.fire({
        title: game === 'race' ? '🏃 Race' : '✊ Rock Paper Scissors',
        text: 'Open another profile to challenge that person.',
        icon: 'info',
        background: '#070707',
        color: '#ffffff',
      });
      return;
    }

    const modal = await this.modalController.create({
canDismiss: true,
      component: ProfileGameComponent,
      componentProps: {
        gameType: game,
        opponentProfile: this.profile,
        currentProfile: this.formService.profile,
      },
      cssClass: 'profile-game-modal',
      backdropDismiss: false,
    });
    await modal.present();
  }

  private relationUsers(raw: any): any[] {
    let data = raw;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { data = []; }
    }
    const relations = Array.isArray(data) ? data : (data?.data || []);
    return relations
      .map((relation: any) => Array.isArray(relation) ? relation[0]?.user_info : relation?.user_info)
      .filter((user: any) => Boolean(user?.profile_id));
  }

  resolveProfilePhoto(photo: any): string {
    let source = photo;
    for (let depth = 0; depth < 3 && source && typeof source === 'object'; depth++) {
      const nestedPhoto = source?.url
        || source?.route
        || source?.path
        || source?.src
        || source?.localUrl
        || source?.photo_url
        || source?.photoUrl
        || source?.profile_photo
        || source?.profilePhoto
        || source?.media?.url;
      if (nestedPhoto === source) {
        break;
      }
      source = nestedPhoto;
    }

    const candidate = typeof source === 'string' ? source.trim() : '';

    if (!candidate || candidate === 'null' || candidate === 'undefined') {
      return 'assets/icon/usuario.png';
    }
    if (/^(https?:|data:|blob:|capacitor:|file:)/i.test(candidate) || candidate.startsWith('assets/')) {
      return candidate;
    }

    return `https://laniakea-multimedia.s3.us-east-1.amazonaws.com/${candidate.replace(/^\/+/, '')}`;
  }

  get currentUserProfilePhoto(): string {
    const signedInProfile = this.formService?.profile;
    return this.resolveProfilePhoto(
      signedInProfile?.profile_photo ||
      signedInProfile?.photo ||
      signedInProfile?.profilePhoto
    );
  }

  useDefaultAvatar(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (image && !image.src.endsWith('/assets/icon/usuario.png')) {
      image.src = 'assets/icon/usuario.png';
    }
  }

  isVerifiedProfile(user: any): boolean {
    const status = user?.Verificacion ?? user?.profile_status_id;
    return user?.kyc === 'Validado'
      || status === 3
      || status === '3'
      || status === true;
  }

  private fetchFriendUsers(profileId: number): Promise<any[]> {
    return this.friendshipService.getAllRelations({
      relationDirection: '3',
      relationType: [1],
      relationStatus: '2',
      page: '1',
      profile_id: String(profileId),
    }).then((raw: any) => this.relationUsers(raw));
  }

  fetchProfileSocialSummary(): void {
    this.profileSocialSummaryLoading = true;
    const signedInProfileId = Number(this.formService?.profile?.id);
    const viewedFriendsRequest = this.fetchFriendUsers(this.profile_id);
    const signedInFriendsRequest = signedInProfileId && signedInProfileId !== this.profile_id
      ? this.fetchFriendUsers(signedInProfileId)
      : Promise.resolve([]);

    Promise.all([viewedFriendsRequest, signedInFriendsRequest]).then(([viewedFriends, signedInFriends]) => {
      const signedInFriendIds = new Set(
        signedInFriends.map((friend: any) => Number(friend.profile_id))
      );
      const mutualFriends = viewedFriends.filter((friend: any) =>
        signedInFriendIds.has(Number(friend.profile_id))
      );

      this.profileSocialSummary = {
        ...this.profileSocialSummary,
        friends: viewedFriends.length,
        mutualFriends: mutualFriends.length,
        mutualPreview: mutualFriends.slice(0, 3),
      };
    }).catch((error) => {
      console.warn('Unable to load profile social summary.', error);
    }).finally(() => {
      this.profileSocialSummaryLoading = false;
    });
  }

  private updateProfileCommentCount(publications: any[]): void {
    // Profile comments have their own persisted counter and are loaded by
    // fetchProfileComments(). Publication comments must not inflate it.
  }

  fetchProfileComments(): void {
    this.request.createRequestGet('profiles', null, { id: this.profile_id }, 'comments')
      .then((raw: any) => {
        const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        this.profileComments = Array.isArray(data?.comments) ? data.comments : [];
        this.profileSocialSummary = {
          ...this.profileSocialSummary,
          comments: Number(data?.count || 0),
        };
      })
      .catch((error) => console.warn('Unable to load profile comments.', error));
  }

  submitProfileComment(): void {
    const body = this.profileCommentDraft.trim();
    if (!body || this.profileCommentSubmitting || this.profile?.owner) return;

    this.profileCommentSubmitting = true;
    this.request.createRequestPost(
      'profiles',
      { body },
      { id: this.profile_id },
      'comments',
    ).then((raw: any) => {
      const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      this.profileComments = Array.isArray(data?.comments) ? data.comments : [];
      this.profileSocialSummary = {
        ...this.profileSocialSummary,
        comments: Number(data?.count || this.profileComments.length),
      };
      this.profileCommentDraft = '';
      return this.socialNotifications.notifySuccessfulInteraction({
        recipientProfileId: this.profile_id,
        remoteTitle: 'New profile comment 💬',
        remoteBody: `@${this.formService?.profile?.username || 'someone'} commented on your profile.`,
        localTitle: 'Comment posted',
        localBody: `Your comment was added to @${this.profile?.username}'s profile.`,
        extra: { interaction_type: 'profile_comment', profile_id: this.profile_id },
      });
    }).catch((error) => {
      console.error('Unable to post profile comment.', error);
    }).finally(() => {
      this.profileCommentSubmitting = false;
    });
  }

  async sendProfileNote(): Promise<void> {
    const result = await Swal2.fire({
      title: '✉️ Send a Note',
      text: `to @${this.profile?.username}`,
      input: 'textarea',
      inputPlaceholder: 'Write a note…',
      inputAttributes: { maxlength: '150' },
      showCancelButton: true,
      confirmButtonText: 'Send Note',
      background: '#070707',
      color: '#ffffff',
      confirmButtonColor: '#ff5f9e',
      inputValidator: (value) => value?.trim() ? null : 'Write a note first.',
    });
    if (!result.isConfirmed) return;

    await this.socialNotifications.notifySuccessfulInteraction({
      recipientProfileId: this.profile_id,
      remoteTitle: `New note from @${this.formService?.profile?.username || 'someone'} ✉️`,
      remoteBody: String(result.value).trim(),
      localTitle: 'Note sent',
      localBody: `Your note was sent to @${this.profile?.username}.`,
      extra: { interaction_type: 'profile_note', profile_id: this.profile_id },
    });
  }

  async sendProfileCrush(): Promise<void> {
    const result = await Swal2.fire({
      title: 'Send a Crush 💘',
      text: `Let @${this.profile?.username} know they caught your attention?`,
      showCancelButton: true,
      confirmButtonText: 'Send Crush',
      background: '#070707',
      color: '#ffffff',
      confirmButtonColor: '#d94cff',
    });
    if (!result.isConfirmed) return;

    await this.socialNotifications.notifySuccessfulInteraction({
      recipientProfileId: this.profile_id,
      remoteTitle: 'Someone sent you a crush 💘',
      remoteBody: `@${this.formService?.profile?.username || 'someone'} sent you a crush.`,
      localTitle: 'Crush sent',
      localBody: `Your crush was sent to @${this.profile?.username}.`,
      extra: { interaction_type: 'profile_crush', profile_id: this.profile_id },
    });
  }

  async shareProfile(): Promise<void> {
    const modal = await this.modalController.create({
      component: ShareProfileModalComponent,
      componentProps: {
        sharedProfile: this.profile,
        sharedProfileId: this.profile_id,
      },
      cssClass: 'share-profile-friends-modal',
      canDismiss: true,
    });
    await modal.present();
  }

  async editTopFive(): Promise<void> {
    if (!this.profile?.owner) return;

    const modal = await this.modalController.create({
      component: ProfileTopFivePickerComponent,
      componentProps: {
        selectedTopFive: this.profileTopFive,
      },
      cssClass: 'profile-tool-sheet-modal',
      canDismiss: true,
    });
    await modal.present();

    const result = await modal.onDidDismiss();
    if (result.data?.saved) {
      this.fetchProfileTopFive();
    }
  }

  handleTopFiveSlot(user: any): void {
    if (user) {
      this.openTopFiveProfile(user);
      return;
    }
    if (this.profile?.owner) {
      this.editTopFive();
    }
  }

  getprofile(){
    this.request.createRequestGet("profile-all",null,{id:this.profile.id}).then((data=>{
      this.profileinfo=JSON.parse(data)
      console.log("profile info",this.profileinfo);
      console.log("email:",this.profileinfo.user.email);
    }))
    .catch(err => console.error(err))
    .finally(() => {
      this.showQubitLoader = false;
    });
  }



  private showQubitLoaderDuringLoad(title = 'Cargando', subtitle = '') {
    this.startProfileSkeletonPhase(title, subtitle);
  }

  private startProfileSkeletonPhase(title = 'Cargando', subtitle = '', persistSkeletonUntilLoad = false) {
    this.qubitTitle = title;
    this.qubitSubtitle = subtitle;
    this.showQubitLoader = !persistSkeletonUntilLoad;
    this.showProfileSkeleton = persistSkeletonUntilLoad;
    this.clearProfileLoaderTimers();
    if (persistSkeletonUntilLoad) return;
    this.profileLoaderTimers.push(setTimeout(() => {
      this.showQubitLoader = false;
      this.showProfileSkeleton = true;
    }, 650));
    this.profileLoaderTimers.push(setTimeout(() => {
      this.showProfileSkeleton = false;
    }, 2800));
  }

  private clearProfileLoaderTimers() {
    this.profileLoaderTimers.forEach((timer) => clearTimeout(timer));
    this.profileLoaderTimers = [];
  }

  async ionViewDidEnter() {
    this.walletService.KYC_validation3(this.profile.id).then((result_kyc) => {
			console.log('KYC_validation result:', result_kyc);
		  if (result_kyc['permit']) {
			this.formService.isKYCValid = true;
		  }else {
        this.formService.isKYCValid = false;
      }
		});
    //this.publications = await this.fetchPublications(true);
    console.log('this profile in sections profile', this.profile);
  }

  Ocultar(){
    if(this.mostrar == true){
      this.Returncss()
      this.mostrar = false
      
      
    }else{
      this.Returncss()
      this.mostrar = true
      
   
    }
  }

  CssClass(){
    this.typeText(this.profile.description,99);
    const contenedor = document.getElementById('masinfo')
    if (contenedor.style.opacity === "0") {
     
      contenedor.style.display = "grid";
      setTimeout(() => {

        
        contenedor.style.opacity = "1";
      }, 200);
      
      console.log("opacity 1");
     
      
      
    } else {
    
      contenedor.style.opacity = "0";
      setTimeout(() => {

        contenedor.style.display = "none";
        
      }, 500);
      

    }
  
  }

  Returncss(){
    return "masinfo"
  }

  async fetchPublications(isrefresh: boolean, pubSection?:any, showLoader: boolean = true){
    const shouldShowLoader = showLoader && (!this.publications || this.publications.length === 0);

    if (shouldShowLoader) {
      this.profilePublicationsLoadError = false;
      this.startProfileSkeletonPhase('Cargando publicaciones', 'Recuperando posts del perfil...', true);
    }

    try {
      // The profile endpoint's default (empty pubSection) is its canonical
      // newest-first ordering. Sending "Reciente" selects a different backend
      // branch and returns older posts first.
      const selectedSection = pubSection || this.actual_publication_section;
      const effectiveSection = selectedSection === 'Reciente' ? undefined : selectedSection;
      const result = await this.actualizacionService.getProfilePublications(null, isrefresh, this.profile_id, false, null, effectiveSection) ;
      // The API is authoritative, but hide Mycelium-only text rows here as a
      // compatibility guard while browser and API deployments roll out.
      const fetchedPublications = (result || []).filter((publication: any) => {
        const source = publication?.__sourcePublication || publication;
        return String(source?.feed_surface || '').toLowerCase() !== 'mycelium';
      });

      // Profile lists can lag briefly behind media uploads. Fetch the new post
      // directly if it is not in the first profile page, then show it first.
      const focusId = Number(this.focusPublicationId);
      if (Number.isSafeInteger(focusId) && focusId > 0) {
        let focusedPublication = fetchedPublications.find(
          (publication: any) => Number(publication?.id) === focusId,
        );
        if (!focusedPublication) {
          try {
            focusedPublication = await this.publicationService.getPublicationByID(focusId, true);
          } catch (error) {
            console.warn('The new profile publication is not available yet:', error);
          }
        }
        if (focusedPublication && Number(focusedPublication.id) === focusId) {
          const remainingPublications = fetchedPublications.filter(
            (publication: any) => Number(publication?.id) !== focusId,
          );
          fetchedPublications.splice(0, fetchedPublications.length, focusedPublication, ...remainingPublications);
        }
      }

      this.filterPublications(fetchedPublications);
      this.updateProfileCommentCount(fetchedPublications);
    } catch (error) {
      console.error('Error loading profile publications:', error);
      this.profilePublicationsLoadError = true;
    } finally {
      if (shouldShowLoader) {
        this.clearProfileLoaderTimers();
        this.showQubitLoader = false;
        this.showProfileSkeleton = false;
      }
    }
  }
  async filterPublications(publications) {
  console.log('filering');
    this.publications = publications;
    this.formService.publications = publications;
   // if (publications.length < 1) {
     // console.log('pub < x');
     // this.actualizacionService.current_page++;
     // await this.fetchPublications(false);
    //}
  
    console.log('siguiendo length of pub', this.publications.length);
  
  
  }

  async fetchPublications2(isrefresh: boolean){
    console.log('pr',this.profile.id);
    const result = await this.actualizacionService.getPublications(null, isrefresh, this.profile.id, false, null);
    if (result.length > 0) {
      return  result;
    }
    if (result.length < 1) {
      console.log('pub < x');
      this.actualizacionService.current_page++;
      await this.fetchPublications(true);
    }
    
  }

	ngOnChanges(changes: SimpleChanges) {
		if (changes['profile'] || changes['profile_id']) {
			this.refreshProfileStories();
			this.loadProfileStories();
		}
		if (changes['actualSection'] != undefined) {
			//console.log("Cambio a la seccion de: " + changes['actualSection'].currentValue);
			this.updateSection();
      if(this.actualSection =='Historias'){
        setTimeout(() => { ///until stories are completely rendered
      this.change_stories_periodically();
    }, 6300);
      }else if(this.actualSection=='Fachada'){
this.profile_facade_sections_controller(true)
      }
		}
		if (changes['focusPublicationId'] && !changes['focusPublicationId'].firstChange
			&& this.actualSection === 'Posts' && this.profile_id) {
			void this.fetchPublications(true);
		}
	}
  change_stories_periodically(){

      if(!this.video_is_playing){
     
    Swal2.fire({
      title: 'Siguiente',
      text: ``,
      icon: 'info',
      timer: 6900, // Show the alert for 6.9 seconds
      timerProgressBar: true,
      toast: true,
      position: 'bottom-end',
      showCancelButton: true,
    showConfirmButton:true,
      cancelButtonText: '<ion-icon name="reload"></ion-icon>No',
      confirmButtonText: '<ion-icon name="play-skip-forward-sharp"></ion-icon>Si',
      color: 'black',
      background: 'white',
      }).then((result) => {
       

        clearTimeout(this.change_story_activated);
        clearInterval(this.change_story_activated);
this.change_story_activated=false;
      if (result.isConfirmed) {


        this.nextPub();
    

      }else{
    


      }

      });

      this.change_story_activated = setTimeout(() => {
      
          this.nextPub();

     
        }, 6300); 
  }

  }
  updateCurrentTime(event: Event){
    const video = event.target as HTMLVideoElement;
    this.video_is_playing=true;
    if (video.currentTime >= video.duration - 6 ) {
      this.video_is_playing=false;
      if(!this.change_story_activated){
        this.change_stories_periodically();
      }
   
    }
  }
  updateDuration(event: Event){
    const video = event.target as HTMLVideoElement;
    const dictationTimer = setInterval(() => {

    const publication = this.stories[this.index];
    if (publication) {

      if (publication.multimediaContainer[0].type === 'Video') {
        const publicationUrl = publication.multimediaContainer[0].url;


  
          // Play the video
          if (video) {
            const videoAbsoluteUrl = new URL(video.currentSrc, window.location.href).href;
            const matchingMediaAbsoluteUrl = new URL(publicationUrl, window.location.href).href;
  
            if (videoAbsoluteUrl === matchingMediaAbsoluteUrl) {
              video.muted = false;
              video.play();
              this.formService.actual_publication=publication;
            }else{
              video.muted = true;
              video.pause();
            }
          }
        
      }
    }
  }, 1000); // Update every second
    console.log('duration', video.duration);
  }
  async slideChanged() {
    this.formService.actual_publication=null;
    this.slides.getActiveIndex().then((index: number) => {
    this.index=index;
    this.change_story_activated=true;
    setTimeout(() => {
    this.change_stories_periodically();
  }, 1200);
  });


  }
  typeText(text: string, delay: number) {

    if (this.typeTextCalled) {
      return;
      }
      this.typeTextCalled = true;


      setTimeout(() => {
        this.typeTextCalled=false;
        }, 69999); 
   
    let index = 0;
    this.profile.description='_';
    console.log( 'typeTextCalled', text);
    const interval = setInterval(() => {
      if (index < text.length) {
        this.profile.description += text.charAt(index);
        index++;
      } else {
        clearInterval(interval);
      }
    }, delay);
  

  }
  async updateSection() {
    this.paginatorIndex = 1;
    switch (this.actualSection) {
      case "Fachada":
        this.reloadProfile.emit();
        this.walletService.KYC_validation3(this.profile.id).then((result_kyc) => {
          console.log('KYC_validation result:', result_kyc);
          if (result_kyc['permit']) {
          this.formService.isKYCValid = true;
          }else {
            this.formService.isKYCValid = false;
          }
        });
        this.formService.titleHeader = '@' + this.profile.username;

          //this.typeText(this.profile.description, 69);
          
       
        break;
      case "Posts":
      case "Publicaciones":
        this.fetchPublications(true);
       // this.publications = await this.fetchPublications(true);
        this.walletService.KYC_validation3(this.profile.id).then((result_kyc) => {
          console.log('KYC_validation result:', result_kyc);
          if (result_kyc['permit']) {
          this.formService.isKYCValid = true;
          }else {
            this.formService.isKYCValid = false;
          }
          this.formService.titleHeader = '@' + this.profile.username;
        });
        break;
      case "Relaciones":
        this.getFriends();
        this.walletService.KYC_validation3(this.profile.id).then((result_kyc) => {
          console.log('KYC_validation result:', result_kyc);
          if (result_kyc['permit']) {
          this.formService.isKYCValid = true;
          }else {
            this.formService.isKYCValid = false;
          }
          this.formService.titleHeader = '@' + this.profile.username;
        });
        break;

      default:
        break;
    }
  }

  swipe(){
    if(this.profilePage.mostrar == true){
      this.profilePage.mostrar=false;
      this.formService.mostrar = false;
      console.log('swiped',this.formService.mostrar );
    }else{
      this.profilePage.mostrar=true;
      this.formService.mostrar = true;
      console.log('swiped',this.formService.mostrar );
    }
  }

	async moreData(event?) {
		switch (this.actualSection) {
			case "Fachada":
				break;
			case "Publicaciones":
				//this.utils.loadingPresent();
        this.fetchPublications(false, null, false); // pagination - don't show full qubit loader
				//this.publications = await this.fetchPublications(false);
        event.target.complete();
				break;
			case "Relaciones":
				this.getFriends();
				break;

			default:
				break;
		}
	}

	async doRefresh(event) {
		this.updateSection();

		setTimeout(() => {

            event.target.complete();
        }, 2000);
    }

	/* PUBLICACIONES */
	public goToPublications(type: string) {

		let title = "";
		let maxImages = 0;

		switch (type) {
			case 'Feed': {

				title = "Nueva Publicación";
				maxImages = 10;
				break;
			}
			case 'Event': {
				title = "Nuevo Evento";
				maxImages = 1;
				break;
			}
			default: {
				title = "Nueva Publicación";
				break;
			}
		}
		let navigationExtras: NavigationExtras = {
			queryParams: {
				type: type,
				title: title,
				maxImages: maxImages,
			}
		};

		this.navCtrl.navigateForward('publications', navigationExtras);
	}

	/*FRIENDS */
	friends_filter_change(filtro){
		this.friendships_filter = filtro;
		this.getFriends(true);
	}

	public getFriends(reset: boolean = true) {
    if (this.loadingRelationsPage) {
      return;
    }
    if (!reset && !this.hasMoreRelations) {
      return;
    }

    if (reset) {
      this.relationPage = 1;
      this.hasMoreRelations = true;
      this.relations = [];
    }

    this.loadingRelationsPage = true;

    // Show the beautiful hardcoded qubit/atom loader while loading
    this.startProfileSkeletonPhase('Cargando sección', 'Sincronizando relaciones y datos del perfil en la red cuántica.');

    let relationType = [2];
    let relationDirection = 3;
    let relationStatus = 2;

    switch (this.friendships_filter) {
      case "Amigos":
        relationDirection = 3;
        relationType = [1];
        break;
      case "Súper Amigos":
        relationDirection = 3;
        relationType = [2];
        break;
      case "Siguiendo":
        relationDirection = 1;
        relationType = [3];
        break;
      case "Seguidores":
        relationDirection = 2;
        relationType = [3];
        break;
      default:
        break;
    }

    const request = {
      queryParams: {
        'relationDirection': relationDirection.toString(),
        'relationType': relationType,
        'relationStatus': relationStatus.toString(),
        'page': this.relationPage.toString(),
      }
    };

    this.friendshipService.getAllRelations(request.queryParams).then((data) => {
      const parsed = JSON.parse(data);
      const incomingRelations = Array.isArray(parsed) ? parsed : (parsed?.data ?? []);

      if (reset) {
        this.relations = incomingRelations;
      } else {
        this.relations = [...(this.relations || []), ...incomingRelations];
      }

      this.hasMoreRelations = incomingRelations.length > 0;
      if (incomingRelations.length > 0) {
        this.relationPage++;
      }

      if (Capacitor.getPlatform() === 'web') {
        console.log('this.relations', this.relations);
      }
    }).catch((error) => {
      console.error('Error loading relations:', error);
    }).finally(() => {
      this.loadingRelationsPage = false;
      this.showQubitLoader = false;
    });

  }

  onRelationsScroll(event: Event) {
    if (this.filteringRelation || this.loadingRelationsPage || !this.hasMoreRelations) {
      return;
    }

    const target = event.target as HTMLElement;
    const threshold = 90;
    const reachedBottom = target.scrollHeight - target.scrollTop - target.clientHeight < threshold;

    if (reachedBottom) {
      this.getFriends(false);
    }
  }

  ngOnDestroy() {
    this.storiesSubscription?.unsubscribe();
    this.clearProfileLoaderTimers();
    this.profileSpotifyController?.destroy?.();
    this.profileSpotifyController = undefined;
    this.profileSpotifyControllerPromise = undefined;
    if (this.relationTextDebounceTimer) {
      clearTimeout(this.relationTextDebounceTimer);
      this.relationTextDebounceTimer = undefined;
    }
    if (this.relationFilterDebounceTimer) {
      clearTimeout(this.relationFilterDebounceTimer);
      this.relationFilterDebounceTimer = undefined;
    }
  }

	//ACERDA DE
	updateProfile(attrib_name:string){
		let array_profile_id = [];
		array_profile_id.push(this.profile_id);
		switch (attrib_name) {
			case "name":
			case "last_name":
			case "rfc":
			case "curp" :
				this.editAlertPrompt(this.profile[attrib_name], attrib_name, 'text');
				break;
			case "birth":
				this.editAlertPrompt(this.profile.birth, attrib_name, 'date');
				break;
			case "number_ine":
				this.editAlertPrompt(this.profile.number_ine, attrib_name, 'number');
				break;
			case "back_ine":
			case "front_ine":

				if(this.profile.kyc != "Validado" && this.profile.kyc != "En Validación"){
					this.cameraService.takePhoto().then((data)=>{
						let array = [];
						array.push(data);

						this.cameraService.postArrayMultimedia(array, array_profile_id, 'profile', attrib_name)
						.finally(()=>{
							this.updateSection();
						});
					}).catch((error)=>{
						console.error(error);
					});
				}

				break;
			default:
				break;
		}
	}

	editAlertPrompt(actualValue, attribName, attribType) {
		this.inputAlertController.InputAlertPrompt(
			"Edita tu información",										//Header
			"",															//Message
			actualValue, 												//Input Value
			attribType, 												//Input Type
			"Actualizar"												//Ok Button Text
		).then((result)=>{
			if(result['action']){
				if (!result['value'].match(/^ *$/)) {
					let updateAttrib = {
						attribute: attribName,
						value: result['value']
					}
					this.profileService.postProfile(updateAttrib).then((data)=>{
						//console.log(data);
						this.profile[attribName] = updateAttrib['value'];
						this.socialNotifications.notifyLocal(
							'Perfil actualizado',
							'Tus cambios se guardaron correctamente.',
							{ event_type: 'profile_updated', attribute: attribName },
						);
					}).catch((error)=>{
						console.error(error);
					});
				}
			}
		});
	}

	borrarPublicacion(publication){
        /*let index = this.publicationResponse.indexOf(publication, 0);
        if (index > -1) {
            this.publicationResponse.splice(index, 1);
        }*/
    }

  async ngAfterViewInit(): Promise<void> {
    this.paginatorIndex = 1;
    //this.publications = await this.fetchPublications(true);
    this.fetchPublications(true);
  }

  private async openConversation(conversation: Conversation): Promise<void> {
    const navigated = await this.router.navigate(['/home/chat-page', conversation.getID()]);
    if (!navigated) throw new Error('Could not navigate to the direct message page.');
  }

  private async hasConfirmedFriendship(): Promise<boolean> {
    // The profile action is the most current relationship state returned by
    // the profile endpoint. It avoids a false negative when the friends list
    // has more than one page.
    if (this.profile?.buttons_info?.friendsButton?.text === 'Amigos') {
      return true;
    }

    const targetProfileId = Number(this.profile?.id || this.profile_id);
    if (!targetProfileId) return false;

    // Fallback for a profile response that has not refreshed its button yet.
    // We paginate the signed-in user's confirmed friends instead of checking
    // just page one of the viewed user's list.
    for (let page = 1; page <= 30; page += 1) {
      const raw = await this.friendshipService.getAllRelations({
        relationDirection: '3',
        relationType: [1],
        relationStatus: '2',
        page: String(page),
      });
      const friends = this.relationUsers(raw);
      if (friends.some((friend: any) => Number(friend?.profile_id || friend?.id) === targetProfileId)) {
        return true;
      }
      if (!friends.length) break;
    }
    return false;
  }

  async sendMessage(): Promise<void> {
    if (this.openingDirectMessage) return;
    this.openingDirectMessage = true;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    try {
      const conversation = await Promise.race([
        this.prepareDirectMessage(),
        new Promise<Conversation>((_, reject) => {
          timeoutId = setTimeout(() => reject(new Error('Direct message request timed out')), 15000);
        }),
      ]);
      if (!conversation) {
        await this.inputAlert.OkInfoMessage(
          'Los mensajes directos requieren amistad',
          'Primero deben ser amigos confirmados para iniciar una conversación directa.',
          'Entendido',
        );
        return;
      }
      await this.openConversation(conversation);
    } catch (error) {
      // A chat backend failure is not evidence that two users are not friends.
      // Keep the actual failure separate from the friendship rule.
      console.error('Unable to start direct message conversation.', error);
      await this.inputAlert.OkInfoMessage(
        'No pudimos abrir el mensaje directo',
        'No se pudo comprobar la amistad o iniciar la conversación. Intenta nuevamente.',
        'Entendido',
      );
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
      this.openingDirectMessage = false;
    }
  }

  private async prepareDirectMessage(): Promise<Conversation | null> {
    if (!await this.hasConfirmedFriendship()) return null;
    const profileId = Number(this.profile?.id ?? this.profile_id);
    if (!Number.isSafeInteger(profileId) || profileId <= 0) {
      throw new Error('The profile did not return a valid chat profile ID.');
    }
    const contact = new UserContact();
    contact.setByResponse(this.profile);
    contact.id = String(profileId);
    return this.chatService.newConversation(contact);
  }

  click_FriendButton(button_info) {
    if (this.friendActionPending) return;
    let header;
    let mensaje;
    let presentConfirmation = true;

    switch (this.profile.buttons_info.friendsButton['text']) {
      case "Agregar":
        this.buttonsActions(button_info);
        presentConfirmation = false;

        //header = this.friendsArrayHeader[0];
        //mensaje = this.friendsArrayMessage[0];
        break;
      case "Pendiente":
        this.buttonsActions(button_info);
        presentConfirmation = false;
        //header = this.friendsArrayHeader[1];
        //mensaje = this.friendsArrayMessage[1];
        break;
      case "Rechazado":
        this.buttonsActions(button_info);
        presentConfirmation = false;
        //header = this.friendsArrayHeader[2];
        //mensaje = this.friendsArrayMessage[2];
        break;
      case "Aceptar":
        this.buttonsActions(button_info);
        presentConfirmation = false;

        //header = this.friendsArrayHeader[3];
        //mensaje = this.friendsArrayMessage[3];
        break;
      case "Amigos":
        header = this.friendsArrayHeader[4];
        mensaje = this.friendsArrayMessage[4];
        break;
    }

    if(presentConfirmation){
      this.actionMessage(header, mensaje, button_info);
    }

  }

  actionMessage(header, mensaje, button_info) {
    this.inputAlertController.BinarySelectorAlert(header,mensaje, 'Aceptar').then((result)=>{
      if(result['action']){
        this.buttonsActions(button_info);
      }
    }).catch((error)=>{
      console.error(error);
    });
  }




  click_FollowButton(button_info) {
    if (this.followActionPending) return;
    switch (this.profile.buttons_info.followButton['text']) {
      case "Seguir":
        this.buttonsActions(button_info);
        break;
      case "Siguiendo":
        this.buttonsActions(button_info);
        break;
    }
  }

  public isProfileFollowed(): boolean {
    const followText = String(this.profile?.buttons_info?.followButton?.text || '').trim().toLowerCase();
    return followText === 'siguiendo' || followText === 'following';
  }

  public clickAvatarFollow(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.followActionPending || !this.profile?.buttons_info?.followButton) {
      return;
    }

    void this.playFollowHaptic();
    this.click_FollowButton(this.profile.buttons_info.followButton);
  }

  private async playFollowHaptic(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await Haptics.impact({ style: 'LIGHT' });
    } catch (_) {
      // Follow remains available when native haptics are unavailable.
    }
  }

  buttonsActions(button_info){
    if(button_info['type'] == 1){
      if (this.friendActionPending) return;
      const previousText = button_info['text'];
      this.friendActionPending = true;

      switch (button_info['text']) {
        case "Agregar":
          this.profile.buttons_info.friendsButton['text']="Pendiente";
          this.createRelation(1).then((data)=>{
            this.utils.presentToast("Se envio la solicitud a "+ this.profile.username);
          }).catch(() => this.profile.buttons_info.friendsButton['text'] = previousText)
            .finally(() => this.friendActionPending = false);
          break;

        case "Pendiente":
          this.profile.buttons_info.friendsButton['text']="Agregar";
          this.deleteRelation(button_info['relation_id']).then((data)=>{
            this.utils.presentToast("Se elimino la solicitud enviada a "+ this.profile.username);
          }).catch(() => this.profile.buttons_info.friendsButton['text'] = previousText)
            .finally(() => this.friendActionPending = false);

          break;

        case "Rechazado":
          this.profile.buttons_info.friendsButton['text']="Pendiente";
          this.updateRelation(1, button_info['relation_id']).then((data)=>{
            this.utils.presentToast("Se envio la solicitud a "+ this.profile.username);
          }).catch(() => this.profile.buttons_info.friendsButton['text'] = previousText)
            .finally(() => this.friendActionPending = false);
          break;

        case "Aceptar":
          this.profile.buttons_info.friendsButton['text']="Amigos";
          this.updateRelation(2, button_info['relation_id']).then((data)=>{
            this.utils.presentToast("Se acepto la solicitud a "+ this.profile.username);
          }).catch(() => this.profile.buttons_info.friendsButton['text'] = previousText)
            .finally(() => this.friendActionPending = false);
          break;

        case "Amigos":
          this.profile.buttons_info.friendsButton['text']="Agregar";
          this.deleteRelation(button_info['relation_id']).then((data)=>{
            this.utils.presentToast("Se elimino la relacion con "+ this.profile.username);
          }).catch(() => this.profile.buttons_info.friendsButton['text'] = previousText)
            .finally(() => this.friendActionPending = false);
          break;
        default:
          this.friendActionPending = false;
      }
    }else if(button_info['type'] == 3){
      if (this.followActionPending) return;
      const previousText = button_info['text'];
      this.followActionPending = true;

      switch (button_info['text']) {
        case "Seguir":
          this.profile.buttons_info.followButton['text']="Siguiendo";
          this.createRelation(3).then((data)=>{
            this.utils.presentToast("Ahora sigues al usuario"+ this.profile.username);
          }).catch(() => this.profile.buttons_info.followButton['text'] = previousText)
            .finally(() => this.followActionPending = false);
          break;
        case "Siguiendo":
          this.profile.buttons_info.followButton['text']="Seguir";
          this.deleteRelation(button_info['relation_id']).then((data)=> {
            this.utils.presentToast("Dejaste de seguir al usuario"+ this.profile.username);
          }).catch(() => this.profile.buttons_info.followButton['text'] = previousText)
            .finally(() => this.followActionPending = false);
          break;
        default:
          this.followActionPending = false;
      }
    }
  }

  createRelation(relation_type): Promise<any>{
    return new Promise((resolve, reject) => {
      let newRelation = {
        'relationUserId': String(this.profile.user_id || this.profile.id),
        'relationType': relation_type.toString()
      };
      this.friendshipService.createRelation(newRelation).then((result)=>{
        result = JSON.parse(result);
        switch (relation_type) {
          case 1:
            this.profile.buttons_info.friendsButton.relation_id = result.relation_id;
            break;
          case 3:
            this.profile.buttons_info.followButton.relation_id = result.relation_id;
            break;

          default:
            break;
        }
        resolve(result);
      }).catch((error) =>{
        reject(error);
      });
    });

  }
  sendNotification() {
   
    return new Promise((resolve, reject) => {
      const notification = {
        title: 'Nuevo vínculo asequido',
        body: `¡Has recibido una nueva relación en tu perfil!`,
        user_id:this.profile.id,

      };
  
      this.request.createRequestPost('GreatAtractorNotifications', notification)
        .then((data) => {
          Swal2.fire({
            title: 'Vínculo generado',
            text: 'Nueva relación asequida exitosamente',
            icon: 'success',
            confirmButtonText: 'Entendido',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
          resolve(data);
        }).catch((error) => {
          console.error('Failed to send notification:', error);
          reject(error);
        });
    });
  }
  
  updateRelation(status_id, relation_id): Promise<any>{
    return new Promise((resolve, reject) => {
      let relationInfo = {
        'relationStatus': status_id.toString()
      };
      let params = {
        'id': relation_id.toString(),
      }
      this.friendshipService.updateRelation(relationInfo, params).then((result) => {
        resolve(result);
      }).catch((error) =>{
        reject(error);
      });
    });

  }

  deleteRelation(relation_id):Promise<any>{
    return new Promise((resolve, reject) => {
      let params = {
        'id': relation_id.toString(),
      };
      this.friendshipService.deleteRelation(params).then((result) => {
        resolve(result);
      }).catch((error) =>{
        reject(error);
      });
    });

  }

  setMultimedia(mediaItem: MediaItem) {
    return new Promise ((resolve,rejects)=> {
      this.uploadMedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
      this.uploadMedia.readBlobFile(mediaItem.mediaPath + mediaItem.nameFile).
      then((result)=>{
        resolve(true);
      });
    });
  }

  update_photo_cover( take_photo: boolean = true,pick_media: boolean = true) {
    Swal2.fire({
			title: '',
			text: '',
			icon: 'success',
			timer: 9999, // Show the alert for 45 seconds
			timerProgressBar: true,
			toast: true,
			position: 'top-start',
			showConfirmButton: false
		  });
    setTimeout(() => {
      this.actionSheetController.dismiss();
      }, 9999); 
    this.type= 'cover_photo';
    console.log('type in upadte_photo', this.type );
    return new Promise((resolve, reject) => {
    if(this.profile.owner) {
      let botonesDisponibles = [
     //   (take_photo) ?
     //     {
     ///       text: 'Tomar una Foto',
        //    icon: 'camera',
    //        handler: () => {
    //          this.takePhoto(type)
    //            .then((mediaItem) => {
    //              resolve([mediaItem,'camera']);
                 // this.setMultimedia(mediaItem).
                 /// then((result)=>{
                    //if(isImage(this.uploadMedia.image)==false){
                      //Swal2.fire({
                        //title: 'Imagen de perfil erronea',
                       // text: 'Asegurate de usar una imagen',
                       // icon: 'warning',
                       // confirmButtonText: 'Entendido',
                      //  color: '#ffffff',
                     //   background: '#010f4e',
                    //  });
                    //}else{
                     // this.uploadMedia.post().then((r)=>{
                       // if(!r[1].includes('image')){
                        //}else{
                         // this.profile_photo= r[0];
                       //   this.postProfilePict(type);
                        //}
                      //}).catch((error)=>{
                      //  console.log(error);
                      //});
           ///         });
                 // });
             //   })
               // .catch((error) => {
                 // console.error(error);
           //     });
          //  }
         // } : null,
        (pick_media) ?
          {
            text: 'Seleccionar desde mi galería',
            icon: 'images',
            handler: () => {
              //this.uploadMedia.image = null;
              this.pickImage().
              then((result)=>{
                resolve([result,'library']);
                //if(isImage(this.uploadMedia.image)==false){
                  //Swal2.fire({
                   // title: 'Imagen de perfil erronea',
                 //   text: 'Asegurate de usar una imagen',
                 //   icon: 'warning',
                //    confirmButtonText: 'Entendido',
               //     color: '#ffffff',
              //      background: '#010f4e',
             //     });
             //   }else{
                 // this.uploadMedia.post().then((r)=>{
                    //if(!r[1].includes('image')){
                    //}else{
                   //   this.profile_photo= r[0];
                   //   this.postProfilePict(type);
                    //}
                 // }).catch((error)=>{
                   // console.log(error);
                 // });
               // }
                          
              });
            }
          } : null,


        {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            //reject(false);
            //console.log('Cancel clicked');
          }
        }
      ];

      botonesDisponibles = botonesDisponibles.filter((boton) => {
        if (boton != null) {
          return true;
        }
        return false;
      });


      this.actionSheetController.create({
        header: '¿Desde donde deseas añadir multimedia?',
        cssClass: 'options-sheet',
        buttons: botonesDisponibles
      }).then((actionSheet) => {
        actionSheet.present();
      });
    } else {
      return;
    }
  });

  }

  postProfilePict( ruta, pub_type,){
    console.log('type in postprofilepict', this.type);
    console.log('type in postProfilePict', this.type);
    console.log('ruta in postProfilePict', ruta);
    console.log('pub_type in postProfilePict', pub_type);
    const requestBody = {
      route: ruta,
      size: 800,
      type: 'imagen',
      publication_type: this.type,
      id:this.profile.id,
    };
    this.request.createRequestPost('profileMultimedia', requestBody)
    .then(() => {
      Swal2.fire({
        title: 'Foto actualizada con éxito',
        icon: 'success',
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
    })
    .catch((error) => {
      console.log("posting new photo profile error", error);
    })
    .finally(() => {
      this.profileService.getProfileInfo().then((data) => {
        this.profile = JSON.parse(data);
      });
    });
  }  

  editar2(){

    Swal2.fire({
      title: 'Edita tu descripción',
      input: 'text',
      inputValue:  this.profile.description,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancelar',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      preConfirm: (description) => {
        this.request.createRequestPost("profile", {'description':description}).then(result=>{

          console.log("json profile description",result);
          this.profile.description = description;
          Swal2.fire({
            title:"Descripcion actualizada con exito",
            timer: 1500,
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
        });
      }


    })

  }

  obtenerJson(){
     this.profile.forEach(element => {

      console.log("json profile G",element);


     });
  }
  fetchCounters(){
    this.request.createRequestGet("CountersFachada", null, { id: this.profile_id })
	  .then((result) => {
		if (result && result.length > 0) {
		  console.log("Successfully fetched Hubble info.");
		  console.log("Hubble info:", result);
  
		  const counters = JSON.parse(result);
		 
      this.counters = counters; 
      if (Capacitor.getPlatform() === 'web') {
        if (typeof result === 'string') {
					result = JSON.parse(result);
					   console.log('json result publication service.ts', result);
             this.counters = result; 
					 }else {
            this.counters = result; 
           }
      }
		 
		} else {
		  console.log("No results found.");
		}
	  })
	  .catch((error) => {
		console.error("Error fetching Hubble info:", error);
	  });
  
  }
  formatCounter(value: number): string  {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return '0';
    }
    const normalizedValue = Number(value);
    if (normalizedValue >= 1000000000000) {
      return (normalizedValue / 1000000000000).toFixed(1) + 'T';
    } else if (normalizedValue >= 1000000000) {
      return (normalizedValue / 1000000000).toFixed(1) + 'B';
    } else if (normalizedValue >= 1000000) {
      return (normalizedValue / 1000000).toFixed(1) + 'M';
    } else if (normalizedValue >= 1000) {
      return (normalizedValue / 1000).toFixed(1) + 'K';
    } else {
      return normalizedValue.toFixed(0);
    }
  }
  
  cambio_busqueda(texto) {
    const normalizedText = (texto ?? '').toString();

    if (normalizedText === this.lastRelationTextValue) {
      return;
    }

    if (this.relationTextDebounceTimer) {
      clearTimeout(this.relationTextDebounceTimer);
    }

    this.relationTextDebounceTimer = setTimeout(() => {
      this.lastRelationTextValue = normalizedText;
      this.texto_buscado = normalizedText;
    }, 300);
	}

	cambio_filtro(filtro) {
		
		this.filtro_actual = filtro;
	}
  async pickImage(){
    console.log('type in pickimage', this.type );
    //const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    try {
      const options: CameraOptions = {
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.Uri,
        source: CameraSource.Photos,
        saveToGallery: false,
      };
      console.log('About to call Camera.getPhoto()');
      const media = await Camera.getPhoto(options);
  
      if (media) {
        console.log('Media picked successfully:', media);
        const imageUrl = Capacitor.convertFileSrc(media.path);
     // imagePreviewElement.src = imageUrl;
        this.mediaType = media.format === 'jpeg' || media.format === 'png' ? 'image' : 'video';
        this.ref.detectChanges();
        const mimeType = media.format === 'jpeg' ? 'image/jpeg' : media.format === 'png' ? 'image/png' : 'video/mp4';
  
        // Read the file as a Blob
        const response = await fetch(media.webPath);
        const blobfile = await response.blob();
  
        // Log the Blob for debugging purposes
        console.log('fileBlob:', blobfile);
        if (Capacitor.getPlatform() !== 'web') {
          this.uploadMedia.filename = media.path.substring(media.path.lastIndexOf('/') + 1);
    }else{
      const currentTime = new Date().toISOString().replace(/:/g, '-').replace(/\./g, '-');
      this.uploadMedia.filename = currentTime + '.png';
    }

        this.uploadMedia.post(blobfile,  this.uploadMedia.filename).then(({ link, mimeType }) => {
          const ruta = link;
          console.log('ruta', ruta);
          let pub_type = '';
          if(mimeType.includes("image")) {
            pub_type= 'imagen';
          }else if(mimeType.includes("video")){
            pub_type= 'video';
          }
          //this.profile_photo= r[0];
          this.postProfilePict( ruta, pub_type);

         }).catch((error)=>{
           console.log(error);
         });
       
      
        
      }
    } catch (error) {
      console.error('Error picking media:', error);
    }
  }  
  public takePhoto(type): Promise<string> {
    return new Promise((resolve, reject) => {
      this.cameraService
        .askForMediCapture()
        .then((data: [MediaItem, string]) => {
          if (data[1].toString() === 'camara') {
           
            this.setMultimediaCamera(data[0], type);
            resolve(data[0].mediaPath + data[0].nameFile);
          } else if (data[1].toString() === 'camvideo') {
           
            console.log("Estoy en video");
            this.setMultimediaVideo(data[0], type);
            resolve(data[0].mediaPath + data[0].nameFile);
          }
         
        })
        .catch((error) => {
          reject(error);
        });
    });
    
  }
  public setMultimediaCamera(mediaItem: MediaItem, type) {
    
    console.log("setMultimediaCamera function called");
    const imagePath = mediaItem.mediaPath + mediaItem.nameFile;
    console.log("Captured image path:", imagePath);
    this.uploadMedia.image = Capacitor.convertFileSrc(imagePath);

    this.uploadMedia.blob = mediaItem.mediaPath;
    this.uploadMedia.filename =  mediaItem.nameFile;

   
    this.uploadMedia.post(mediaItem.mediaPath, mediaItem.nameFile).then(({ link, mimeType }) => {
      const ruta = link;
      console.log('ruta', ruta);
      //this.profile_photo= r[0];
      let pub_type = '';
      if(mimeType.includes("image")) {
        pub_type= 'imagen';
      }else if(mimeType.includes("video")){
        pub_type= 'video';
      }
      this.postProfilePict( ruta, pub_type);

  }).catch((error)=>{
    console.log(error);
  });
  
  }
  setMultimediaVideo(mediaItem: MediaItem, type) {
    
    this.uploadMedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
    const videoSourceElement = document.getElementById("videoSource") as HTMLSourceElement;
  
  videoSourceElement.src = this.uploadMedia.image;
  this.uploadMedia.blob = mediaItem.mediaPath;
  this.uploadMedia.filename =  mediaItem.nameFile;
  this.uploadMedia.post(mediaItem.mediaPath, mediaItem.nameFile).then(({ link, mimeType }) => {
    const ruta = link;
    console.log('ruta', ruta);
    //this.profile_photo= r[0];
    let pub_type = '';
      if(mimeType.includes("image")) {
        pub_type= 'imagen';
      }else if(mimeType.includes("video")){
        pub_type= 'video';
      }
    this.postProfilePict( ruta, pub_type);

}).catch((error)=>{
  console.log(error);
});
 
  }
  update_photo_profile( text_to_image: boolean = true,pick_media: boolean = true) {
    Swal2.fire({
			title: '',
			text: '',
			icon: 'success',
			timer: 9999, // Show the alert for 45 seconds
			timerProgressBar: true,
			toast: true,
			position: 'top-start',
			showConfirmButton: false
		  });
    setTimeout(() => {
      this.actionSheetController.dismiss();
      }, 9999); 
     this.type= 'profile_photo';
    console.log('type in upadte_photo', this.type );
    return new Promise((resolve, reject) => {
    if(this.profile.owner) {
      let botonesDisponibles = [
        (text_to_image) ?
          {
            text: 'Crear foto cuántica',
            icon: 'images',
            handler: () => {
              this.AI()
                .then((mediaItem) => {
                  resolve([mediaItem,'camera']);
          
                    });
        
            }
          } : null,
        (pick_media) ?
          {
            text: 'Seleccionar desde mi galería',
            icon: 'camera',
            handler: () => {
              //this.uploadMedia.image = null;
              this.pickImage().
              then((result)=>{
                resolve([result,'library']);
       
                          
              });
            }
          } : null,


        {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            //reject(false);
            //console.log('Cancel clicked');
          }
        }
      ];

      botonesDisponibles = botonesDisponibles.filter((boton) => {
        if (boton != null) {
          return true;
        }
        return false;
      });


      this.actionSheetController.create({
        header: '¿Desde donde deseas añadir multimedia?',
        cssClass: 'options-sheet',
        buttons: botonesDisponibles
      }).then((actionSheet) => {
        actionSheet.present();
      });
    } else {
      return;
    }
  });

  }

  handleProfilePhotoClick(event?: Event): void {
    event?.stopPropagation();

    if (this.profileHasStories) {
      this.openProfileStories();
      return;
    }

    if (this.profile?.owner) {
      this.update_photo_profile();
      return;
    }

    const profilePhoto = this.profile?.profile_photo;
    const photoUrl = this.resolveProfilePhoto(profilePhoto);
    if (!profilePhoto || photoUrl === 'assets/icon/usuario.png') {
      return;
    }

    const media = new MediaItem({
      ...profilePhoto,
      url: photoUrl,
      // MultimediaView renders `route`; using the normalized URL prevents
      // external profiles with an S3 key-only route from opening as a blank
      // modal.
      route: photoUrl,
    });
    this.cameraService.openMediaInModal([media]);
  }

  handleProfilePhotoKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleProfilePhotoClick(event);
    }
  }

  private openProfileStories(): void {
    if (!this.profileStoryPublications.length) {
      return;
    }

    this.modalController.create({
      component: StoryViewerComponent,
      cssClass: 'detailsInModal',
      canDismiss: true,
      componentProps: {
        stories: this.profileStoryPublications,
        tapped: 0,
      },
    }).then(modal => modal.present()).catch(error => {
      console.error('Error opening profile Stories:', error);
    });
  }

  private refreshProfileStories(): void {
	const userIds = [
	  this.profile?.user_id,
	  this.profile?.userId,
	  this.profile?.user?.user_id,
	  this.profile?.user?.userId,
	  this.profile?.user?.id,
	];
	const profileIds = [
	  this.profile_id,
	  this.profile?.profile_id,
	  this.profile?.profileId,
	  this.profile?.id,
	];
	this.profileStoryPublications = this.publicationService.getStoriesForAuthor(
	  userIds,
	  [this.profile?.username, this.profile?.userName],
	  this.profile?.profile_photo,
	  profileIds,
	);
	this.updateProfileStoryIndicator();
  }

  private loadProfileStories(): void {
    const requestSequence = ++this.storyRequestSequence;
    const profileId = this.profile?.id
      ?? this.profile_id
      ?? this.profile?.profile_id
      ?? this.profile?.profileId;
	const userIds = [
	  this.profile?.user_id,
	  this.profile?.userId,
	  this.profile?.user?.user_id,
	  this.profile?.user?.userId,
	  this.profile?.user?.id,
	];
	const usernames = [
      this.profile?.username,
      this.profile?.userName,
    ];

    this.publicationService.loadStoriesForAuthor(
      profileId,
      userIds,
      usernames,
      this.profile?.profile_photo,
	).then(stories => {
      if (requestSequence !== this.storyRequestSequence) {
        return;
      }

	      this.profileStoryPublications = Array.isArray(stories) ? stories : [];
	      this.updateProfileStoryIndicator();
	      this.ref.markForCheck();
    }).catch(() => {
      // Keep the existing profile photo and navigation behavior when the
      // optional targeted Stories lookup is unavailable.
    });
	  }

  private updateProfileStoryIndicator(): void {
    this.profileHasStories = this.profileStoryPublications.length > 0;
    this.profileHasUnseenStories = this.publicationService.hasUnseenStories(
      this.profileStoryPublications,
      this.formService.profile,
    );
    this.profileAllStoriesSeen = this.publicationService.areAllStoriesSeen(
      this.profileStoryPublications,
      this.formService.profile,
    );
  }
  public async AI(){
    
    // Use the Router to navigate to the "messages-page"
    this.router.navigate(['home/messages-page']);
    this.formService.fromCreatePublication=true;
    this.router.navigateByUrl('home/messages-page', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }
  async navigateToWebPage(url) {
    if (!url) {
      Swal2.fire({
        title: 'Sin enlace',
        text: 'El usuario no tiene enlace todavía',
        icon: 'info',
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return;
    }
    //let url = this.profile.WebPage;
  
    // Check if "https://" is already present in the URL
    if (!url.startsWith('https://')) {
      url = 'https://' + url;
    }
  
    if (Capacitor.getPlatform() !== 'android') {
      await Browser.open({ url });
    }else{
      this.open_android_iab(url);
      }
  }
  
  open_android_iab(loginUrl){
    const browser = window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');

    const interval = setInterval(() => {
      if (browser?.closed) {
      clearInterval(interval);
      console.log('Window was closed.');
      }
    }, 500);
    }
 
    
    async editar(): Promise<void> {
      const modal = await this.modalController.create({
        component: ProfileEditModalComponent,
        componentProps: { profile: this.profile },
        cssClass: 'profile-tool-sheet-modal',
        canDismiss: true,
      });
      await modal.present();

      const { data, role } = await modal.onDidDismiss();
      if (role !== 'save' || !data) return;

      try {
        await this.saveDescription(data.description, data.webPages);
        await this.savePublicDiscoveryLocation(data.publicCity, data.publicCountryCode, data.publicLocationEnabled);
        this.profile.description = data.description;
        this.profile.WebPage = data.webPages;
        this.profile.public_city = data.publicCity || null;
        this.profile.public_country_code = data.publicCountryCode || null;
        this.profile.public_location_enabled = data.publicLocationEnabled;
        this.formattedURLs = [...data.webPages];
        this.ref.detectChanges();
      } catch (error) {
        console.error('Unable to update profile links.', error);
      }
    }


    displayURLs() {
      if (this.profile.WebPage && typeof this.profile.WebPage === 'string') {
        try {
          const urlsArray = JSON.parse(this.profile.WebPage);
          if (Array.isArray(urlsArray)) {
            this.formattedURLs = urlsArray.map(url => url ? url.trim() : null);
            console.log('Profile urls:', this.formattedURLs);
          }
        } catch (error) {
          console.error('Error parsing WebPage property:', error);
        }
      }
    }
    getIconName(index: number): string {
      // Implement logic to return the appropriate icon name based on the index
      // For example:
      const iconNames = [
        'link-outline', 'logo-apple-appstore', 'logo-google-playstore',
        'logo-facebook', 'logo-instagram', 'logo-snapchat',
        'logo-tiktok', 'logo-twitch', 'logo-twitter',
        'logo-youtube', 'logo-whatsapp', 'logo-reddit', 'logo-wechat'
      ];
      return iconNames[index] || 'link-outline'; // Default to link-outline if index is out of range
    }
        
    
    
    
    
    
    
    
    saveDescription(description: string, webPages): Promise<void> {
      // Perform the necessary actions to save the edited description and webpage
      //this.isEditing = false;
    
      const object = {
        WebPage: webPages,
        Description: description,
        profile_id: this.profile.id
      };
    
      return this.request.createRequestPost('saveWebPageAndDescription', object)
        .then((data) => {
          console.log('Web page and description saved:', data);
        })
        .catch((error) => {
          console.log('API error:', error);
          throw error;
        });
    }

    private savePublicDiscoveryLocation(city: string, countryCode: string, enabled: boolean): Promise<void> {
      return this.request.createRequestPost('profile/public-discovery-location', {
        city,
        country_code: countryCode,
        enabled,
      });
    }

    
    async presentProfileActionSheet(){
      Swal2.fire({
        title: '',
        text: '',
        icon: 'success',
        timer: 9999, // Show the alert for 45 seconds
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false
        });
      setTimeout(() => {
        this.actionSheetController.dismiss();
        }, 9999); 
      const actionSheet = await this.actionSheetController.create({
        header: 'Acerca del perfil',
        cssClass: 'title-action',
        buttons: [ {
          text: 'Copiar enlace del perfil',
          icon: 'link-outline',
          cssClass: 'icon',
          handler: () => {
            if (Capacitor.getPlatform() !== 'web') {   
this.click_on_share();

}else{
  const url = this.publicProfileUrl();
  navigator.clipboard.writeText(url).then(() => {
    Swal2.fire({
      title: 'Respuesta copiada!',
      text: 'La respuesta ha sido copiado en el portapapeles.',
      icon: 'success',
      timer: 2000, // Show the alert for 2 seconds
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
      });
  }).catch((error) => {
    //console.error(error);
  });
}
          }
        }, {
          text: 'Compartir con otras aplicaciones',
          icon: 'analytics-outline',
          cssClass: 'icon',
          handler: () => {
            if (Capacitor.getPlatform() !== 'web') {   
            this.Share();
           
          
          }else{
            void this.sharePublicProfileOnWeb();
          }
          }
        }, 
  
       
      ]
      });
      await actionSheet.present();
  
      const { role } = await actionSheet.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    
    }
    click_on_share() {
      const url = this.publicProfileUrl();
    
      // Copy the URL to clipboard
      this.clipboard.copy(url)
        .then(() => {
          console.log('URL copied to clipboard:', url);
          Swal2.fire({
            title: '¡URL copiado!',
            text: 'El URL ha sido copiado en el portapapeles.',
            icon: 'success',
            timer: 2000, // Show the alert for 2 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-end',
            showConfirmButton: false
          });
        })
        .catch((error) => {
          console.error('Error copiando el URL en el portapapeles:', error);
          Swal2.fire({
            title: 'Error',
            text: 'Error copiando el URL en el portapapeles.',
            icon: 'error',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000 // Show the alert for 2 seconds
          });
        });
    }
    async Share(){
      const url = this.publicProfileUrl();
      await Share.share({
        url: url,
      });
    }

    private publicProfileUrl(): string {
      const username = encodeURIComponent(String(this.profile?.username || '').trim());
      return `https://supercumulo.laniakea.tv/profile/${this.profile_id}${username ? '/' + username : ''}`;
    }

    private updatePublicProfileMetadata(): void {
      const username = String(this.profile?.username || 'perfil');
      const fullName = [this.profile?.name, this.profile?.last_name].filter(Boolean).join(' ').trim() || username;
      const bio = String(this.profile?.description || '').replace(/\s+/g, ' ').trim();
      const description = (bio || `Descubre el perfil público de @${username} en Laniakea.`).slice(0, 155);
      const title = `${fullName} (@${username}) | Laniakea`;
      const url = this.publicProfileUrl();
      const image = this.profile?.photo || this.profile?.profile_photo || 'https://laniakea-multimedia.s3.us-east-1.amazonaws.com/imagenes/profile_default.png';

      this.titleService.setTitle(title);
      this.metaService.updateTag({ name: 'description', content: description });
      this.metaService.updateTag({ property: 'og:type', content: 'profile' });
      this.metaService.updateTag({ property: 'og:title', content: title });
      this.metaService.updateTag({ property: 'og:description', content: description });
      this.metaService.updateTag({ property: 'og:url', content: url });
      this.metaService.updateTag({ property: 'og:image', content: image });
      this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
      this.metaService.updateTag({ name: 'twitter:title', content: title });
      this.metaService.updateTag({ name: 'twitter:description', content: description });
      this.metaService.updateTag({ name: 'twitter:image', content: image });

      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = url;
    }

    private async sharePublicProfileOnWeb(): Promise<void> {
      const url = this.publicProfileUrl();
      const title = `${this.profile?.name || this.profile?.username || 'Perfil'} | Laniakea`;
      const text = `Descubre el perfil de @${this.profile?.username || ''} en Laniakea.`;

      try {
        if (navigator.share) {
          await navigator.share({ title, text, url });
        } else {
          await navigator.clipboard.writeText(url);
          await Swal2.fire({
            title: 'Enlace copiado', text: 'Compártelo donde quieras.', icon: 'success',
            timer: 1800, timerProgressBar: true, toast: true, position: 'top-end', showConfirmButton: false,
          });
        }
      } catch (error) {
        // Closing the native sharing UI is not an error worth showing.
        if ((error as Error)?.name !== 'AbortError') console.warn('Profile sharing failed.', error);
      }
    }

// Handle the search bar input change
onSearchChange(searchValue: string) {
  const normalizedSearch = (searchValue ?? '').trim().toLowerCase();

  if (normalizedSearch === this.lastRelationFilterValue && this.filteredRelations?.length) {
    this.filteringRelation = normalizedSearch.length > 0;
    return;
  }

  if (this.relationFilterDebounceTimer) {
    clearTimeout(this.relationFilterDebounceTimer);
  }

  this.relationFilterDebounceTimer = setTimeout(() => {
    this.lastRelationFilterValue = normalizedSearch;

    if (!normalizedSearch) {
      this.filteringRelation = false;
      this.filteredRelations = [];
      return;
    }

    const cachedResult = this.relationSearchCache.get(normalizedSearch);
    if (cachedResult) {
      this.filteringRelation = true;
      this.filteredRelations = cachedResult;
      return;
    }

    this.filteringRelation = true;
    const sourceRelations = this.relations || [];
    const filtered = sourceRelations.filter((relation) => {
      const relationEntry = Array.isArray(relation) ? relation[0] : relation;
      const buttonsInfo = relationEntry?.buttons_info as { [key: string]: any };
      const fullName = (relationEntry?.user_info?.full_name || '').toString().toLowerCase();
      const username = (relationEntry?.user_info?.username || '').toString().toLowerCase();

      return (
        fullName.includes(normalizedSearch) ||
        username.includes(normalizedSearch) ||
        Object.values(buttonsInfo || {}).some((button) =>
          button && typeof button.text === 'string' && button.text.toLowerCase().includes(normalizedSearch)
        )
      );
    });

    this.filteredRelations = filtered;
    this.relationSearchCache.set(normalizedSearch, filtered);
  }, 250);
}
BlockUser() {
  Swal2.fire({
    title: `Bloquear a usuario: ${this.profile.username}`,
    text: `¿Estás seguro que deseas bloquear al usuario ${this.profile.username}? Se van a suprimir los mensajes directos y comentarios en publicaciones entre sí.`,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    color: '#ffffff',
    background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
  }).then((result) => {
    if (result.isConfirmed) {
      const notification = {
        user_id: this.formService.profile.id,
      };
      // Call your desired function here
      this.request.createRequestPost('toggleBlockStatus', notification)
        .then((data) => {
          Swal2.fire({
            title: 'El status ha sido actualizado',
            text: 'La lista de tus usuarios bloqueados ha sido actualizada con éxito.',
            icon: 'error',
            confirmButtonText: 'Entendido',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
          this.navCtrl.navigateForward('search');
          // Handle the success case
        })
        .catch((error) => {
          console.error('The user might be indeed blocked:', error);
          Swal2.fire({
            title: 'Error al actualizar el status de bloqueo',
            text: 'Si el error persiste, comunícate con el soporte de Laniakea',
            icon: 'error',
            confirmButtonText: 'Entendido',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
        });
    }
  });
}

nextPub() {

  this.slides.slideNext(); // Method to move to the next slide
  
}
backPub(){
  this.slides.slidePrev(); // Method to move to the next slide
}
eraseExperience(index: number, id?) {
  this.experiences.splice(index, 1);
  // Optionally, you can also make an API call here to persist the change
  this.permanently_delete_profile_facade_section_record(id);
}

eraseEducation(index: number, id?) {
  this.educationList.splice(index, 1);
  // Optionally, persist the change
  this.permanently_delete_profile_facade_section_record(id);
}

eraseLanguage(index: number, id?) {
  this.languages.splice(index, 1);
  this.permanently_delete_profile_facade_section_record(id);
  // Optionally, persist the change
}

eraseSkill(index: number, id?) {
  this.skills.splice(index, 1);
  // Optionally, persist the change
  this.permanently_delete_profile_facade_section_record(id);
}
eraseCause(index: number, id?) {
  this.causes.splice(index, 1);
  // Optionally, persist the change
  this.permanently_delete_profile_facade_section_record(id);
}
permanently_delete_profile_facade_section_record(id){
  this.request.createRequestPost('profile_facade_sections_controller', {id:id, delete:true})
  .then((final_data) => {
console.log('final_data',final_data);
Swal2.fire({
  title: 'perfil actualizado',
  text: 'El perfil se actualizará en 30 segundos.',
  icon: 'success',
  confirmButtonText: 'Entendido',
  color: '#ffffff',
  background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
});
});
}

ADD_TO_PROFILE_SECTION(SECTION: string) {
  if (SECTION === 'EDUCATION') {
    Swal2.fire({
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      title: 'Agregar Educación',
      html: `
        <input id="institution" class="swal2-input" placeholder="Institución">
        <input id="degree" class="swal2-input" placeholder="Título o Grado">
        <input id="year" class="swal2-input" placeholder="Año de finalización (ej. 2023)">
        <input id="logoUrl" class="swal2-input" placeholder="URL del logo de la institución">
      `,
      focusConfirm: false,
      preConfirm: () => {
        const institution = (document.getElementById('institution') as HTMLInputElement).value;
        const degree = (document.getElementById('degree') as HTMLInputElement).value;
        const year = (document.getElementById('year') as HTMLInputElement).value;
        const logoUrl = (document.getElementById('logoUrl') as HTMLInputElement).value;

        if (!institution || !degree || !year || !logoUrl) {
          Swal2.showValidationMessage('Por favor, complete todos los campos');
          return false;
        }

        return { institution, degree, year, logoUrl };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const { institution, degree, year, logoUrl } = result.value;
        console.log('Educación agregada:', { institution, degree, year, logoUrl });
        this.profile_facade_sections_controller(false, result.value, 'EDUCATION');
      }
    });
  } else if (SECTION === 'LANGUAGES') {
    Swal2.fire({
      title: 'Agregar Idioma',
      input: 'text',
      inputLabel: 'Por favor, ingrese el idioma',
      inputPlaceholder: 'Ingrese el nombre del idioma',
      showCancelButton: true,
      confirmButtonText: 'Agregar',
      cancelButtonText: 'Cancelar',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      preConfirm: (language) => {
        if (!language) {
          Swal2.showValidationMessage('Por favor, ingrese un idioma');
        }
        return language;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const language = result.value;
        console.log('Idioma agregado:', language);
        this.profile_facade_sections_controller(false, result.value, 'IDIOMAS');
      }
    });
  } else if (SECTION === 'SKILLS') {
    Swal2.fire({
      title: 'Agregar Habilidad',
      input: 'text',
      inputLabel: 'Por favor, ingrese la habilidad',
      inputPlaceholder: 'Ingrese el nombre de la habilidad',
      showCancelButton: true,
      confirmButtonText: 'Agregar',
      cancelButtonText: 'Cancelar',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      preConfirm: (skill) => {
        if (!skill) {
          Swal2.showValidationMessage('Por favor, ingrese una habilidad');
        }
        return skill;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const skill = result.value;
        this.profile_facade_sections_controller(false, result.value, 'HABILIDADES');
        console.log('Habilidad agregada:', skill);
      }
    });
  } else if (SECTION === 'EXPERIENCE') {
    Swal2.fire({
      title: 'Agregar Experiencia',
      html: `
        <input id="position" class="swal2-input" placeholder="Cargo">
        <input id="company" class="swal2-input" placeholder="Empresa">
        <input id="duration" class="swal2-input" placeholder="Duración (ej. Feb 2022 - Jun 2022)">
        <textarea id="description" class="swal2-textarea" placeholder="Descripción"></textarea>
        <input id="companyLogoUrl" class="swal2-input" placeholder="URL del logo de la empresa">
      `,
      focusConfirm: false,
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      preConfirm: () => {
        const position = (document.getElementById('position') as HTMLInputElement).value;
        const company = (document.getElementById('company') as HTMLInputElement).value;
        const duration = (document.getElementById('duration') as HTMLInputElement).value;
        const description = (document.getElementById('description') as HTMLTextAreaElement).value;
        const logoUrl = (document.getElementById('companyLogoUrl') as HTMLInputElement).value;
    
        if (!position || !company || !duration || !description || !logoUrl) {
          Swal2.showValidationMessage('Por favor, complete todos los campos');
          return false; // This ensures that the form will not be submitted if validation fails
        }
    
        return {
          position,
          company,
          duration,
          description,
          logoUrl
        };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        // Now safely access the properties since the result is confirmed and valid
        const { position, company, duration, description, logoUrl } = result.value;
        console.log('Experiencia agregada:', { position, company, duration, description, logoUrl });
        this.profile_facade_sections_controller(false, result.value, 'EXPERIENCE');
      }
    });
    
  } else if (SECTION === 'CAUSAS') {
    Swal2.fire({
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      title: 'Causas benéficas',
      html: `
        <ul style="list-style:none; padding:0; text-align:left;" id="checklist">
          <li><input type="checkbox" id="animal"> Protección de animales</li>
          <li><input type="checkbox" id="art"> Arte y cultura</li>
          <li><input type="checkbox" id="childhood"> Infancia</li>
          <li><input type="checkbox" id="civil-rights"> Derechos civiles y acción social</li>
          <li><input type="checkbox" id="economic"> Potenciamiento económico</li>
          <li><input type="checkbox" id="education"> Educación</li>
          <li><input type="checkbox" id="environment"> Medio ambiente</li>
          <li><input type="checkbox" id="health"> Salud</li>
          <li><input type="checkbox" id="human-rights"> Derechos humanos</li>
          <li><input type="checkbox" id="politics"> Política</li>
          <li><input type="checkbox" id="science"> Ciencia y tecnología</li>
          <li><input type="checkbox" id="social-services"> Servicios sociales</li>
          <li><input type="checkbox" id="veterans"> Asistencia para veteranos del ejército</li>
        </ul>
      `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const selectedOptions: string[] = [];
        const unselectedOptions: string[] = [];

        const options = document.querySelectorAll('#checklist input[type="checkbox"]');
        options.forEach(option => {
          const checkbox = option as HTMLInputElement;

          if (checkbox.checked) {
            selectedOptions.push(checkbox.parentElement?.textContent?.trim() || '');
          } else {
            unselectedOptions.push(checkbox.parentElement?.textContent?.trim() || '');
          }
        });

        return {
          selected: selectedOptions,
          unselected: unselectedOptions
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Selected:', result.value.selected);
        console.log('Unselected:', result.value.unselected);
        this.profile_facade_sections_controller(false, result.value.selected, 'CAUSAS');
        Swal2.fire({
          title: 'Selection Summary',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          html: `
            <strong>Selected:</strong> <br> ${result.value.selected.join(', ')} <br><br>
            <strong>Unselected:</strong> <br> ${result.value.unselected.join(', ')}
          `
        });
      }
    });
  }
}
profile_facade_sections_controller( get?, data_chunk?, section_type?){
  if(data_chunk)
{
  this.request.createRequestPost('profile_facade_sections_controller', { data_chunk:data_chunk, section_type:section_type})
  .then((final_data) => {
console.log('final_data',final_data);
Swal2.fire({
  title: 'perfil actualizado',
  text: 'El perfil se actualizará en 30 segundos.',
  icon: 'success',
  confirmButtonText: 'Entendido',
  color: '#ffffff',
  background: '#010f4e',
  position: 'top-end',
  timerProgressBar: true,
  toast: true,
});
  })

}else if(get){
  this.request.createRequestPost('profile_facade_sections_controller', { get: true })
  .then((final_data) => {
    if (final_data && typeof final_data === 'string') {
      try {
        final_data = JSON.parse(final_data);
        console.log('getRecordByToken ios:',final_data);
      } catch (error) {
        console.error("Error parsing data:", error);
      }
      }
    console.log('final_data', final_data);

    if (final_data.title) {
      final_data.title.forEach((item) => {
        switch (item.section_type) {
          case 'EXPERIENCE':
            this.experiences.push(item);
            console.log('Experience:', item.data_chunk);
            // Handle EXPERIENCE section logic here
            break;

          case 'CAUSAS':
            this.causes.push(item);
            
            console.log('Causas Benéficas:', item.data_chunk);
            // Handle CAUSAS section logic here
            break;

          case 'IDIOMAS':
            this.languages.push(item);
            console.log('Idiomas:', item.data_chunk);
            // Handle IDIOMAS section logic here
           
            break;

          case 'HABILIDADES':
            console.log('Habilidades:', item.data_chunk);
            this.skills.push(item);
            // Handle HABILIDADES section logic here
            break;

          case 'EDUCATION':
               this.educationList.push(item);
           
            console.log('Educación:', item.data_chunk);
            // Handle EDUCATION section logic here
            break;

          default:
            console.log('Unknown section type:', item.section_type);
        }
      });
    }
  });

}
}
}
